import { render, staticRenderFns } from "./LampControlCabinetControllerTelemetryCard.vue?vue&type=template&id=0b5d8698&scoped=true&"
import script from "./LampControlCabinetControllerTelemetryCard.vue?vue&type=script&lang=ts&"
export * from "./LampControlCabinetControllerTelemetryCard.vue?vue&type=script&lang=ts&"
import style0 from "./LampControlCabinetControllerTelemetryCard.vue?vue&type=style&index=0&id=0b5d8698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d8698",
  null
  
)

export default component.exports